import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import config from "../../../config/config";
import NumberFormat from "react-number-format";
import { remove } from "react-icons-kit/fa/remove";
import Icon from "react-icons-kit";
const convenienceFee = config.convenienceFee;

const BillingCustomeComponent = inject("sharedStore")(observer(class BillingCustomeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      amount: {},
      payableAmount: 0,
      serviceFee: 0,
      errorAmount: {},
      errorMessage: {},
    };
    this.textInput = React.createRef();
  }


  handleCheckClick = () => {
    this.setState({ checked: !this.state.checked });
  };

  numberWithCommas(x) {
    let val = parseFloat(x)
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return val;
  }

  getTotalPayableAmount = () => {
    const { paymentType } = this.props;
    let service_amount = 0;
    let amount =
      Object.values(this.state.amount).length > 0 &&
      Object.values(this.state.amount).reduce((acc, val) => {
        let formattedVal = val.replace(/[, ]+/g, "").trim();
        return acc + parseFloat(formattedVal);
      }, 0);
    if (
      paymentType &&
      paymentType.length > 0 &&
      paymentType[0].type === "card"
    ) {
      service_amount = ((amount * convenienceFee) / 100).toFixed(2);
      amount = parseFloat(service_amount) + amount;
    }

    this.setState({
      payableAmount: this.numberWithCommas(amount),
      serviceFee: this.numberWithCommas(service_amount),
    });
    return amount;
  };

  shiftValue = (event, propertyName, balance) => {
    let values = {
      formattedValue: balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    };
    const { formattedValue } = values;
    const amount = { ...this.state.amount };
    amount[propertyName] = formattedValue;
    this.setState({ amount });
  };

  onValueChange(values, propertyName, open_balance) {
    const errorAmount = { ...this.state.errorAmount };
    const amount = { ...this.state.amount };
    let { formattedValue, value } = values;
    errorAmount[propertyName] = value > open_balance ? true : false;
    amount[propertyName] =
      formattedValue.length > 1 && formattedValue >= 1
        ? formattedValue.replace(/^0+/, "")
        : formattedValue;
    this.setState({ amount, errorAmount, errorMessage: [] });
  }

  validateNextButton() {
    const { paymentType } = this.props;
    let totalAmount = this.getTotalPayableAmount();
    const errorAmount = { ...this.state.errorAmount };
    let errorArr = Object.values(errorAmount);
    errorArr = errorArr.includes(true);
    let error = false;
    let msg = {};
    let paymentMethod =
      paymentType && paymentType.length > 0 ? paymentType[0].type : "card";
    if (errorArr) {
      error = true;
      msg["amount"] = "Payment is larger than current balance ";
    } else if (totalAmount < 0.5) {
      error = true;
      msg["amount"] = "Payment amount cannot be less than $0.50";
    } else if (totalAmount >= 999999 && paymentMethod === "card") {
      error = true;
      msg["amount"] =
        "Payment amount cannot be greater than $999,999. If you are paying with credit card, this includes the convenience fee that will be applied at checkout.";
    } else if (totalAmount >= 999999 && paymentMethod === "bank") {
      error = true;
      msg["amount"] = "Payment amount cannot be greater than $999,999 ";
    }
    if (!this.props.paymentId) {
      error = true;
      this.props.dropdownError(true);
    }
    if (totalAmount === 0) {
      error = true;
      msg["amount"] = "Please enter a payment amount";
    }

    this.setState({
      errorMessage: msg,
    });

    return error;
  }
  onBlur = (e, propertyName) => {
    const amount = { ...this.state.amount };
    amount[propertyName] =
      amount[propertyName] === "" || amount[propertyName] === 0
        ? "0.00"
        : amount[propertyName] < 1 && amount[propertyName] > 0
        ? "0" + amount[propertyName]
        : amount[propertyName];
    this.setState({ amount });
  };

  removeInputValue = (e, propertyName, type) => {
    const { screen } = this.props;
    if (screen === 2) {
      document.getElementById(propertyName).focus();
      const amount = { ...this.state.amount };
      amount[propertyName] =
        amount[propertyName] === undefined ||
        amount[propertyName] === "0.00" ||
        type === "remove"
          ? ""
          : amount[propertyName];
      this.setState({ amount });
    }
  };

  isAllowed = () => {};

  renderInvoiceList = () => {
    const { screen } = this.props;
    const { invoicesData } = this.props.sharedStore;

    return (
      invoicesData &&
      invoicesData
        .filter((val) => val.is_paid !== 1 && val.is_paid !== 2)
        .map((val, i) => {
          let invoice_id = `${val.invoice_id}`;
          let invoice_no = `INV-${val.invoice_no}`;
          return (
            <tr>
              <td>{invoice_no}</td>
              <td>${this.numberWithCommas(val.balance_due)}</td>
              <td>
                {val.open_balance == null
                  ? 0
                  : "$" + this.numberWithCommas(val.open_balance)}
              </td>
              <td className="td-center">
                {screen === 3 ? (
                  <span className="pay_arrowicons">
                    <i className="fa fa-arrow-right" aria-hidden="true" />
                  </span>
                ) : (
                  <span
                    className="pay_arrowicons"
                    onClick={(e) =>
                      this.shiftValue(e, invoice_id, val.open_balance)
                    }
                  >
                    <i className="fa fa-arrow-right" aria-hidden="true" />
                  </span>
                )}
              </td>
              <td>
                <span className="currency_sign">$</span>

                <NumberFormat
                  id={invoice_id}
                  value={this.state.amount[invoice_id]}
                  fixedDecimalScale={true}
                  defaultValue="0.00"
                  allowLeadingZeros={false}
                  isAllowed={(values) => {
                    const { value } = values;
                    return value === "" || value.length <= 9;
                  }}
                  onBlur={(e) => this.onBlur(e, invoice_id)}
                  onFocus={(e) => this.removeInputValue(e, invoice_id, "focus")}
                  className={
                    this.state.errorAmount[invoice_id]
                      ? "cus_pay_input error"
                      : "cus_pay_input"
                  }
                  decimalScale={2}
                  disabled={screen === 2 ? false : true}
                  allowNegative={false}
                  thousandSeparator={true}
                  // autoFocus
                  onValueChange={(values) =>
                    this.onValueChange(values, invoice_id, val.open_balance)
                  }
                />
                {screen === 2 ? (
                  <span
                    className="cls_cusamount"
                    onClick={(e) =>
                      this.removeInputValue(e, invoice_id, "remove")
                    }
                  >
                    <Icon size={20} icon={remove} />
                  </span>
                ) : null}
              </td>
            </tr>
          );
        })
    );
  };

  moveScreen(e, number) {
    e.preventDefault();
    let check = this.validateNextButton();
    if (!check || number < this.props.screen) {
      this.props.dropdownError(false);
      const { setScreen } = this.props;
      setScreen(e, number);
      if (this.props.screen === 2) {
        this.setState({
          checked: false,
        });
      }
    }
  }

  displayError() {
    let { errorMessage } = this.state;
    let values = Object.values(errorMessage);
    return (
      values &&
      values.map((err) => {
        return <div>{err}</div>;
      })
    );
  }

  callPaymentApi = (e) => {
    e.preventDefault();
    const { callPaymentIntent, paymentType } = this.props;
    const { amount } = this.state;
    let cus_amount = {};
    // eslint-disable-next-line array-callback-return
    Object.keys(amount).map((val, index) => {
      if (amount[val] !== "0.00") {
        cus_amount[val] = amount[val];
      }
    });

    if (paymentType && paymentType.length > 0) {
      let data = {
        type: paymentType[0].type,
        id: paymentType[0].id,
        invoice: cus_amount,
        flag: true,
      };
      var result = this.props.sharedStore.invoicesData.filter((elem) =>
        Object.keys(cus_amount).find((id) => {
          return String(elem.invoice_id) === id;
        })
      );
      let conversionExist = this.props.extractHeader(result);
      callPaymentIntent(data, conversionExist);
    }
  };

  render() {
    const { screen, paymentType } = this.props;
    const { payableAmount, checked, serviceFee } = this.state;
    return (
      <div className="custom_paywrapper">
        <div className="cusheadtxt modal-header">
          <h3>Custom Payment</h3>
        </div>
        <div className="cus_payTable">
          <table width="100%">
            <thead>
              <tr>
                <th>Invoice</th>
                <th>
                  Original <br />
                  Balance
                </th>
                <th>
                  Current <br />
                  Balance
                </th>
                <th>&nbsp;</th>
                <th>
                  Enter
                  <br /> Payment
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>&nbsp;</td>
              </tr>
              {this.renderInvoiceList()}
              <tr>
                <td colSpan="3" align="right">
                  <strong>
                    {" "}
                    {this.props.screen === 3 &&
                    paymentType &&
                    paymentType.length > 0 &&
                    paymentType[0].type === "card"
                      ? "3% Convenience Fee"
                      : null}
                  </strong>
                </td>
                <td />
                <td>
                  <strong>
                    {this.props.screen === 3 && serviceFee !== 0.0
                      ? `$${serviceFee}`
                      : null}
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
          {this.props.screen === 3 ? (
            <div className="payDetails-10 adjust-text input consent">
              <input
                type="checkbox"
                className="billing-check"
                checked={checked}
                onChange={this.handleCheckClick}
              />
              I authorize Izenda to electronically debit my account and, if
              necessary, electronically credit my account to correct erroneous
              debits.
            </div>
          ) : null}
          {screen === 2 ? (
            <div className="cyspay_fotterTxt">
              Note: Current balance includes any credits applied to the invoice
            </div>
          ) : null}
          <div className="cus_pay_contant">
            <span
              className="cus_cancel"
              onClick={(e) => this.moveScreen(e, screen - 1)}
            >
              Back
            </span>
            {screen === 2 ? (
              <button
                className="btn custom_btn"
                onClick={(e) => this.moveScreen(e, 3)}
              >
                Continue
              </button>
            ) : (
              <button
                className="btn btn-common"
                disabled={!checked || payableAmount === "0.00"}
                onClick={this.callPaymentApi}
              >
                Pay ${payableAmount}
              </button>
            )}
            <div className="error_msg">
              {screen === 2 ? this.displayError() : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}));

export default BillingCustomeComponent;



// WEBPACK FOOTER //
// ./src/components/Profile/BillingComponent/BillingCustomComponent.jsx